@if (dataPoints$ | async) {
  <app-temperature-chart-tile
    [title]="title"
    [colors]="colors"
    [applicationId]="applicationId"
    [chartOptions]="chartOptions"
    [series]="series$ | async"
    [dataPoints$]="dataPoints$"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-temperature-chart-tile>
}
